import { createSlice } from "@reduxjs/toolkit";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: localStorage.getItem("token") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
    username: localStorage.getItem("username") || null,
    //localStorage can only store strings.
    user: JSON.parse(localStorage.getItem("user")) || null,
    partner: JSON.parse(localStorage.getItem("partner")) || null,
    contractor: JSON.parse(localStorage.getItem("contractor")) || null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { username, partner, contractor, access, refresh, user } = action.payload;
      state.username = username;
      state.user = user;
      state.partner = partner;
      state.contractor = contractor || user?.contractor || null;
      state.token = access;
      if (refresh) {
        state.refreshToken = refresh;
        localStorage.setItem("refreshToken", refresh);
      }

      localStorage.setItem("token", access);
      localStorage.setItem("username", username);
      //localStorage can only store strings.
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("partner", JSON.stringify(partner));
      localStorage.setItem("contractor", JSON.stringify(state.contractor));
    },
    logOut: (state, action) => {
      state.username = null;
      state.token = null;
      state.refreshToken = null;
      state.partner = null;
      state.contractor = null;
      state.user = null;

      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("username");
      localStorage.removeItem("user");
      localStorage.removeItem("partner");
      localStorage.removeItem("contractor");

      // Sign out from Firebase to clear social login state (Google/Apple)
      if (auth.currentUser) {
        signOut(auth).catch((error) => {
          console.error("Firebase sign out error:", error);
        });
      }
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
export const selectRefreshToken = (state) => state.auth.refreshToken;
